export default __webpack_public_path__ + "static/media/native-section-desk.af0b803c.png";